export default "__VITE_ASSET__DrBjG$JL__"